import React from 'react';
import { useUserProfile } from '../../../hooks/useUserProfile';
import { Checkbox } from "react-daisyui";
import { useTranslation } from 'react-i18next';

const EmailNotification: React.FC = () => {
    const { localProfile, handleLocalProfileChange } = useUserProfile();
    const { t } = useTranslation();

    if (localProfile === undefined) {
        return null; // or return a loading indicator
    }

    return (
        <>
            <h1 className="text-3xl font-bold mb-6">
                {t('profilePages.emailNotification.title')}
            </h1>
            <div className="space-y-8">
                <div>
                    <h2 className="text-xl font-semibold mb-4">{t('profilePages.emailNotification.preferences')}</h2>
                    <div className="form-control">
                        <label className="label cursor-pointer">
                            <Checkbox
                                checked={localProfile.email_consent || false}
                                onChange={(e) => {
                                    handleLocalProfileChange('email_consent', e.target.checked);
                                }}
                            />
                            <span className="label-text ml-2">{t('profilePages.emailNotification.consentText')}</span>
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmailNotification;
